import { PERMISSIONS, ROUTE_PATHS } from "../PermissionsConstants";
import Agreements from "./Agreements";
import ProducerCodeDashboard from "./ProducerCode";
import CarrierModule from "./Carrier";
import PolicyFee from "../PolicyFee";
import {
  RectangleStackIcon,
  NewspaperIcon,
  QrCodeIcon,
  CreditCardIcon,
} from "@heroicons/react/24/solid";

export const CarrierAgreementMgmtTabs = [
  {
    to: ROUTE_PATHS.CarrierAgreementMgmt_carriers,
    icon: <RectangleStackIcon className="h-4 w-4 mr-2" />,
    label: "Carrier Module",
    component: CarrierModule,
    permission: PERMISSIONS.permission_carrieragreemnentmgmt_carrier_view,
  },
  {
    to: "/carrieragreementmgmt/agreements",
    icon: <NewspaperIcon className="h-4 w-4 mr-2 " />,
    label: "Agreement Module",
    component: Agreements,
    permission: PERMISSIONS.permission_carrieragreemnentmgmt_agreement_view,
  },
  {
    to: "/carrieragreementmgmt/producercodeconfig",
    icon: <QrCodeIcon className="h-4 w-4 mr-2 " />,
    label: "Producer Code Module ",
    component: ProducerCodeDashboard,
    permission: PERMISSIONS.permission_carrieragreemnentmgmt_producercode_view,
  },
  {
    to: "/carrieragreementmgmt/policyfee",
    icon: <CreditCardIcon className="h-4 w-4 mr-2 " />,
    label: "Policy Fee",
    component: PolicyFee,
    permission: PERMISSIONS.permission_policyfee_view,
  },
];
